<template>
    <div class="scc-team-sharing">
        <h1 class="scc-team-sharing__title">{{ title }}</h1>
        <div class="scc-team-sharing__container">
            <div class="scc-team-sharing__inner-container">
                <p>{{ teamLink }}</p>
                <div class="scc-team-sharing__button" @click.stop.prevent="copyLink">{{ copyButtonText }}</div>
            </div>
            <div class="scc-team-sharing__inner-container">
                <VueQrcode id="qrcode" ref="qrcode" class="scc-team-sharing__qr" :value="teamLink" />
                <div class="scc-team-sharing__button" @click="downloadCode">{{ qrButtonText }}</div>
            </div>
            <div class="scc-team-sharing__inner-container">
                <h3 class="scc-team-sharing__title">{{ shareTitle }}</h3>
                <div class="scc-team-sharing__networks">
                    <ShareNetwork
                        network="facebook"
                        :url="teamLink"
                        :title="socialTitle"
                        :description="socialDescription"
                    >
                        <FacebookIcon />
                    </ShareNetwork>
                    <ShareNetwork
                        network="twitter"
                        :url="teamLink"
                        :title="socialTitle"
                        :description="socialDescription"
                    >
                        <TwitterIcon />
                    </ShareNetwork>
                    <ShareNetwork
                        network="linkedin"
                        :url="teamLink"
                        :title="socialTitle"
                        :description="socialDescription"
                    >
                        <LinkedinIcon />
                    </ShareNetwork>
                    <ShareNetwork
                        network="whatsapp"
                        :url="teamLink"
                        :title="socialTitle"
                        :description="socialDescription"
                    >
                        <WhatsappIcon />
                    </ShareNetwork>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './team-sharing.scss';
import VueQrcode from 'vue-qrcode';
import WhatsappIcon from '../../assets/icons/whatsapp.vue';
import FacebookIcon from '../../assets/icons/facebook.vue';
import LinkedinIcon from '../../assets/icons/linkedin.vue';
import TwitterIcon from '../../assets/icons/twitter.vue';

export default {
    name: 'TeamSharing',
    components: { VueQrcode, WhatsappIcon, FacebookIcon, LinkedinIcon, TwitterIcon },
    __editor: {
        fields: {},
    },
    props: {
        team: {
            type: Object,
        },
        title: {
            type: String,
            default: 'Jouw teamlink delen',
        },
        copyButtonText: {
            type: String,
            default: 'Link kopiëren',
        },
        qrButtonText: {
            type: String,
            default: 'Download QR-code',
        },
        shareTitle: {
            type: String,
            default: 'Deel jouw teamlink',
        },
        socialTitle: {
            type: String,
            default: 'Doe mee met de Amateurvoetbal loterij en win!',
        },
        socialDescription: {
            type: String,
            default:
                'Doe mee met de Amateurvoetbal loterij en steun de vereniging van jouw keuze! Met je deelname maak je bovendien kans op geweldige (voetbal)prijzen!',
        },
    },
    computed: {
        affiliateId() {
            return this?.team?.id;
        },
        teamLink() {
            let baseUrl = window.location.protocol + '//' + window.location.host + this.$router.options.base;
            return baseUrl + `?affiliate=${this.affiliateId}`;
        },
    },
    methods: {
        downloadCode() {
            const link = document.createElement('a');
            link.href = document.getElementById('qrcode').src;
            link.setAttribute('download', 'teamlink-qr-code.png'); //or any other extension
            document.body.appendChild(link);
            link.click();
        },
        copyLink() {
            let input = document.createElement('input');
            input.setAttribute('value', this.teamLink);
            document.body.appendChild(input);
            input.select();
            input.setSelectionRange(0, 99999); /* For mobile devices */
            let result = document.execCommand('copy');
            document.body.removeChild(input);
            return result;
        },
    },
};
</script>
